import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * PM tracker service stores — Premier's PM workbook, from Josh's 2026-10-19
 * walkthrough. Backed by the API services in `project/pm-*`.
 *
 * enableStorage is OFF on all four: the dashboard reads them fresh on entry,
 * and a cached copy of a job someone else archived would linger on screen
 * (the 08-27 ghost-record shape). Plain ServiceStore — do not add these to
 * autoOfflineStores.
 */
export const pmStores: ServiceStoreConfig[] = [
  { name: "pm-jobs", options: { enableStorage: false, enableErrorNotifications: true } },
  { name: "pm-checklist-items", options: { enableStorage: false, enableErrorNotifications: true } },
  { name: "pm-checklist-templates", options: { enableStorage: false, enableErrorNotifications: true } },
  { name: "pm-documents", options: { enableStorage: false, enableErrorNotifications: true } },
];
